import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import SEO from "../Seo";
import { ToastContainer } from "react-toastify";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { thirdparty } from "../..";
import TableComponent from "./TableComponent";
import { formatDate } from "../../utils/utils";

const UserLog = () => {
    const [fatchData, setFatchdata] = useState([]);

    const fetchData = async () => {
        try {
            const response = await thirdparty.get("/user_log");
            if (response.status === 200) {
                setFatchdata(response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const columns = [
        { header: "#", accessor: (_, index) => index + 1 },
        { header: "Date-Time", accessor: (item) => formatDate(item.created_at) },
        { header: "Type", accessor: "type" },
        { header: "IP Add.", accessor: "ip_address" },
        {
            header: "Role",
            accessor: (item) =>
                item.user_mave && item.user_mave.roles
                    ? item.user_mave.roles.role_name
                    : "-",
        },
        {
            header: "Name",
            accessor: (item) => (item.user_mave ? item.user_mave.fullname : "-"),
        },
        {
            header: "System",
            accessor: (item) => `${item.browser}, ${item.os}, ${item.device}`,
        },
        { header: "URL", accessor: "url" },
    ];

    return (
        <div className="fixed-left">
            <SEO
                title="User Log "
                description="User Log - United Hospital"
                pathSlug="/admin/user-log"
                keywords="User Log"
            />
            <div id="wrapper">
                <Route component={LeftSidebar} />
                <div className="content-page">
                    <div className="content">
                        <Route component={TopHeader} />
                        <div className="page-content-wrapper ">
                            <TableComponent title="User Log" data={fatchData} columns={columns} />
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer autoClose={5000} />
        </div>
    );
};

export default UserLog;



// WEBPACK FOOTER //
// ./src/component/admin/user_log.js